
<script>
import NewForm from "./New";
export default {
  mixins: [NewForm],
  data() {
    return {
      edit: true,
    };
  },
  methods: {
    load() {
      this.$http.get(`/divisions/${this.$route.query.id}`).then((res) => {
        this.form = { ...res.data };
      });
      this.$http.get("/companies/kv").then((res) => {
        this.companies = res.data;
      });
    },
    back() {
      this.$router.go(-1);
    },
    save() {
      this.$http
        .put(`/divisions/${this.$route.query.id}`, this.form)
        .then(() => {
          this.$router.go(-1);
        });
    },
    remove() {
      this.$confirm({ content: this.$t("app.messages.removeConfirm") }).then(
        () => {
          return this.$http
            .delete(`divisions/${this.$route.query.id}`)
            .then(() => {
              this.$router.go(-1);
              this.$message("", "削除成功");
            });
        }
      );
    },

    // loadBUs() {
    //   if (this.form.type === 'DEPARTMENT' && this.form.company.id) {
    //     this.$http
    //       .get('divisions/kv', {
    //         params: { type: 'BU', companyId: this.form.company.id }
    //       })
    //       .then(res => {
    //         this.BUs = res.data
    //       })
    //   } else {
    //     this.BUs = []
    //   }
    // }
  },
  mounted() {
    this.load();
  },
};
</script>
